import { useCallback, type ComponentType } from 'react';
import { useModal, type ModalProps } from '@/contexts/ModalContext';
import { DuplicateWorkoutModal } from '~/workout/components/duplicate-workout-modal/DuplicateWorkoutModal';
import type { WorkoutRecord } from '~/powersync/generated/schema';

export interface UseWorkoutDuplicateResult {
  /** Open the duplicate-workout dialog for the given workout. */
  dispatchDuplicateDialog: (workout: WorkoutRecord) => void;
}

/**
 * Opens the {@link DuplicateWorkoutModal} for a workout. Mirrors the
 * dispatch-a-modal shape of `useConfirmation`. The modal defaults the new
 * planned date to today.
 */
export const useWorkoutDuplicate = (): UseWorkoutDuplicateResult => {
  const { showModal } = useModal();

  const dispatchDuplicateDialog = useCallback(
    (workout: WorkoutRecord) => {
      // `showModal` types its component as `ComponentType<ModalProps>` (an
      // index-signature bag); cast to bridge our specifically-typed modal props
      // (same rough edge the other dispatch hooks hit).
      showModal(DuplicateWorkoutModal as unknown as ComponentType<ModalProps>, {
        workoutId: workout.id,
        workoutName: workout.name ?? '',
      });
    },
    [showModal],
  );

  return { dispatchDuplicateDialog };
};
